export default __webpack_public_path__ + "static/Montserrat-Bold-7dbcc8a5ea2289d83f657c25b4be6193.woff2";